// import 'highcharts/modules/no-data-to-display';

import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useEffect, useState } from 'react';

// Initialize no-data module

const AreaChartView = ({ data }: any) => {
  const [chartOptions, setChartOptions] = useState({});

  useEffect(() => {
    const items = data?.items ?? [];

    const colors = [
      '#E55050',
      '#008048',
      '#35B1E8',
      '#FFA51F',
      '#FEBEC8',
      '#4C5167',
      '#008044',
      '#35B1E8',
    ];

    const seriesData = items.map((item: any, index: number) => ({
      name: item.Name || `Item ${index + 1}`,
      y: item.BookingValue ?? 0,
      RevenueValue: item.RevenueValue,
      color: colors[index % colors.length],
    }));

    setChartOptions({
      chart: { type: 'column' },
      title: {
        text: 'Areawise Revenue',
        style: { fontSize: '13px' },
      },
      xAxis: {
        type: 'category',
        labels: { style: { fontSize: '11px' } },
      },
      yAxis: {
        title: {
          text: 'Value',
          style: { fontSize: '16px', fontWeight: 'bold' },
        },
        labels: { style: { fontSize: '10px' } },
      },
      tooltip: {
        useHTML: true,
        formatter: function (this: any) {
          return `
            <b>Name:</b> ${this.point.name}<br/>
            <b>Booking:</b> ${this.point.y}<br/>
            <b>Revenue:</b> KD ${this.point.RevenueValue}<br/>
          `;
        },
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
          dataLabels: {
            enabled: false,
            format: '{y}',
            style: { fontSize: '14px' },
          },
        },
      },
      legend: {
        itemStyle: { fontSize: '10px' },
      },
      credits: { enabled: false },
      series: [
        {
          name: 'Area',
          colorByPoint: false,
          data: seriesData,
        },
      ],
      lang: {
        noData: 'No data found',
      },
      noData: {
        style: {
          fontWeight: 'bold',
          fontSize: '14px',
          color: '#666',
        },
      },
    });
  }, [data]);

  return <HighchartsReact highcharts={Highcharts} options={chartOptions} />;
};

export default AreaChartView;
